(() => {
  'use strict';
  const source = document.getElementById('FultonsBreadcrumbConfig');
  const nav = document.getElementById('FultonsBreadcrumbs');
  if (!source || !nav || window.FultonsBreadcrumbsReady) return;
  window.FultonsBreadcrumbsReady = true;
  const config = JSON.parse(source.textContent);
  const aliases = {'type-coffee-tables':'type-coffee-side-tables','type-side-tables':'type-coffee-side-tables','type-bookcases':'type-bookcases-storage','type-media-units':'type-storage-media','type-dressers':'type-chests-dressers','type-bar-stools':'type-stools'};
  const categoryFor = tags => {
    const normalized = new Set((tags || []).map(tag => aliases[tag] || tag));
    return config.categories.find(item => normalized.has(item.tag));
  };
  const href = path => {
    const url = new URL(path, location.origin);
    if (config.draft) url.searchParams.set('preview_theme_id', String(config.themeId));
    return url.pathname + url.search + url.hash;
  };
  const initial = [...nav.querySelectorAll('.fultons-breadcrumbs__trail li')].map(item => ({label:item.textContent.trim(),url:item.querySelector('a')?.getAttribute('href')}));
  let signature = '';
  function render(parts) {
    const next = JSON.stringify(parts);
    if (next === signature) return;
    signature = next;
    const trail = nav.querySelector('ol');
    trail.replaceChildren(...parts.map((part,index) => {
      const li = document.createElement('li');
      const item = document.createElement(part.url ? 'a' : 'span');
      item.textContent = part.label;
      if (part.url) item.href = href(part.url);
      else if (index === parts.length - 1) item.setAttribute('aria-current','page');
      li.append(item);
      return li;
    }));
    const parent = [...parts].reverse().find(part => part.url);
    const link = nav.querySelector('.fultons-breadcrumbs__parent');
    link.href = href(parent.url);
    link.lastElementChild.textContent = parent.label;
  }
  function refresh() {
    const main = document.getElementById('MainContent');
    if (!main) return;
    const roomHero = document.body.classList.contains('fo-room-page') && main.querySelector('.fo-room-landing .living-test__intro');
    if (roomHero) {
      if (roomHero.nextElementSibling !== nav) roomHero.after(nav);
    } else if (nav.parentElement !== main || main.firstElementChild !== nav) main.prepend(nav);
    nav.hidden = false;
    const requestedProduct = new URL(location.href).searchParams.get('draft_product');
    if (config.offerProduct && (!requestedProduct || String(requestedProduct).split('/').pop() === String(config.productId))) {
      render(initial);
      return;
    }
    const selected = String(requestedProduct || config.productId || '');
    const draft = selected && [...(window.FultonsDraftProducts || []),...(window.FultonsStressless?.catalogue || [])].find(item => String(item.id).split('/').pop() === selected);
    if (config.pageType === 'product' || draft) {
      const category = categoryFor(draft?.tags || config.productTags);
      const parts = [{label:config.home,url:config.rootUrl}];
      if (category?.room) parts.push({label:category.room,url:category.roomUrl});
      parts.push({label:category?.label || config.furniture,url:category?.url || config.allUrl});
      const title = main.querySelector('.catalogue-proof:not([hidden]) h1,.pdp-refined:not([hidden]) h1')?.textContent.trim();
      parts.push({label:title || draft?.title || initial.at(-1).label});
      render(parts);
    } else {
      render(initial);
    }
  }
  document.addEventListener('fultons:catalogue-updated',refresh);
  document.addEventListener('shopify:section:load',refresh);
  window.addEventListener('pageshow',refresh);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',refresh,{once:true});
  else refresh();
})();

